import SubmissionWrapper from '../SubmissionWrapper';
import PerPageSkeleton from '../SharedPagination/PerPageDropdown/Skeleton';
import SharedPaginationSkeleton from '../SharedPagination/Skeleton';
import SubmissionCardSkeleton from '../SubmissionCard/Skeleton';
import Skeleton from 'react-loading-skeleton';

export default function SubmissionSkeleton({ perPage, hideElement }: { perPage: number; hideElement?: boolean }) {
  return (
    <SubmissionWrapper
      paginationComponent={<SharedPaginationSkeleton />}
      perPageDropDownComponent={<PerPageSkeleton />}
      title={
        <div className='[&_br]:hidden'>
          <Skeleton height={36} width={'80%'} className='mb-6 flex justify-center mx-auto' />
          <Skeleton height={36} width={800} className='mb-6 flex justify-center mx-auto' />
        </div>
      }
    >
      {Array.from({ length: perPage }).map((_, index) => (
        <SubmissionCardSkeleton key={index} hideElement={hideElement} />
      ))}
    </SubmissionWrapper>
  );
}
